
import { memo } from "react";
import { Collection } from "@/contexts/collections/types";
import {
  UrlField,
  TitleField,
  DescriptionField,
  ContentTypeField,
  CollectionField,
  TagField
} from "@/components/forms/fields/ContentFormFields";

interface ContentFormFieldsProps {
  url: string;
  title: string;
  description: string;
  contentType: string;
  selectedCollection: string;
  collections: Collection[];
  selectedTags?: string[];
  setUrl: (url: string) => void;
  setTitle: (title: string) => void;
  setDescription: (description: string) => void;
  setContentType: (type: string) => void;
  setSelectedCollection: (collection: string) => void;
  onTagToggle: (tagId: string) => void;
}

// Memoize the component to prevent unnecessary re-renders
const ContentFormFields = memo(({
  url,
  title,
  description,
  contentType,
  selectedCollection,
  collections,
  selectedTags = [],
  setUrl,
  setTitle,
  setDescription,
  setContentType,
  setSelectedCollection,
  onTagToggle,
}: ContentFormFieldsProps) => {
  console.log('[ContentFormFields] Rendering with collections count:', collections.length);
  
  return (
    <div className="space-y-4">
      <UrlField url={url} setUrl={setUrl} />
      <TitleField title={title} setTitle={setTitle} />
      <DescriptionField description={description} setDescription={setDescription} />
      <TagField selectedTags={selectedTags} onTagToggle={onTagToggle} />
      <ContentTypeField contentType={contentType} setContentType={setContentType} />
      <CollectionField 
        selectedCollection={selectedCollection} 
        setSelectedCollection={setSelectedCollection}
        collections={collections}
      />
    </div>
  );
});

ContentFormFields.displayName = "ContentFormFields";

export default ContentFormFields;
